
import { defineComponent, computed } from "vue";
// import { onMounted } from "vue";
import { useStore } from "vuex";

import { mdiCheck } from "@mdi/js";
import TimerBar from "@/components/Games/TimerBar.vue";
import AppIcon from "@/components/AppIcon.vue";
import GameMetaData from "@/components/Games/GameMetaData.vue";

export default defineComponent({
  name: "riddles",
  components: {
    TimerBar,
    AppIcon,
    GameMetaData,
  },
  setup() {
    //
    const store = useStore();
    const riddle = computed(() => store.getters.getRiddle);
    const riddleAnswerLen = computed(() => store.getters.getRiddleAnswerLength);
    // const currentTime = computed(() => store.getters.getCurrentTime);
    // watch it and calculate the remaining time before the round/turn ends
    // const timer = computed(() => store.getters.getTimer);

    // const remainingTimeBeforeEnd = ref<number>(-1);
    // let remainingTimeInterval: number | null = null;

    // watch(timer, (newVal: number | null, prevVal: number | null) => {
    //   if (prevVal !== null && newVal === null) {
    //     // set the remaining time to what the current time is equal to when stopped
    //     remainingTimeBeforeEnd.value = currentTime.value;
    //     // tirgger the count down
    //     remainingTimeInterval = setInterval(() => {
    //       remainingTimeBeforeEnd.value -= 1;
    //       // if the reamaining timer is at 0, clear the interval
    //       if (remainingTimeBeforeEnd.value === 0 && remainingTimeInterval) {
    //         clearInterval(remainingTimeInterval);
    //       }
    //     }, 1000);
    //   }
    // });

    // onUnmounted(() => {
    //   if (remainingTimeInterval !== null) clearInterval(remainingTimeInterval);
    // });

    return {
      // currentTime,
      // currentRound: computed(() => store.getters.getCurrentRound),
      // remainingTimeBeforeEnd,
      riddle,
      riddleAnswerLen,
      riddleAnswer: computed(() => store.getters.getWord),
      playerFoundAnswer: computed(() => store.getters.getPlayerFoundAnswer),
      // playerFoundAnswer: true,
      //
      mdiCheck,
    };
  },
});
